import en from './en';
import es from './es';
import de from './de';
import pt from './pt';
import tr from './tr';
import ar from './ar';
import zh from './zh';

export type Locale = 'en' | 'es' | 'de' | 'pt' | 'tr' | 'ar' | 'zh';

export type TranslationParams = Record<string, string | number>;

/** ISO 3166-1 alpha-2 para flagcdn.com */
export const localeMeta: Record<
  Locale,
  { name: string; flagCode: string; dir: 'ltr' | 'rtl' }
> = {
  en: { name: 'English', flagCode: 'gb', dir: 'ltr' },
  es: { name: 'Español', flagCode: 'es', dir: 'ltr' },
  de: { name: 'Deutsch', flagCode: 'de', dir: 'ltr' },
  pt: { name: 'Português', flagCode: 'pt', dir: 'ltr' },
  tr: { name: 'Türkçe', flagCode: 'tr', dir: 'ltr' },
  ar: { name: 'العربية', flagCode: 'sa', dir: 'rtl' },
  zh: { name: '中文', flagCode: 'cn', dir: 'ltr' },
};

export const supportedLocales = Object.keys(localeMeta) as Locale[];

type Catalog = Record<string, string>;

function asCatalog(mod: Record<string, string>): Catalog {
  return { ...mod };
}

/** Catálogos completos por idioma; fallback a EN si falta alguna clave. */
export const catalogs: Record<Locale, Catalog> = {
  en: asCatalog(en),
  es: { ...en, ...es },
  de: { ...en, ...de },
  pt: { ...en, ...pt },
  tr: { ...en, ...tr },
  ar: { ...en, ...ar },
  zh: { ...en, ...zh },
};
